import { connect, ConnectedProps } from 'react-redux';

import { RootState } from 'src/redux/store';
import {
  selectors as individualDashboardSelectors,
  selectors,
  selectors as idbSelectors,
} from 'src/routes/IndividualDashboard/modules/dashboard/slice';
import {
  actions as alertActions,
  selectors as alertsSelectors,
} from 'src/redux/data/alerts';
import dayjs from 'dayjs';
import { DATA_FETCHING_STATUS } from 'src/redux/data/constants';

const mapStateToProps = (state: RootState) => ({
  patientNotifications: Object.values(
    alertsSelectors.selectOngoingAlertsByPatientId(
      state,
      idbSelectors.getCurrentPatientId(state) ?? '',
    ),
  ).sort((a1, a2) => (dayjs(a1.startTime).isAfter(a2.startTime) ? -1 : 1)),
  timeFrame: selectors.selectTimeFrame(state),
  isLoading:
    selectors.selectAlertsLogStatus(state) === DATA_FETCHING_STATUS.LOADING,
  alertLogMetadata: individualDashboardSelectors.selectAlertsLogMetadata(state),
});

const mapActionCreators = {
  clearAllPatientAlerts: alertActions.clearAllPatientAlerts,
};

const Connector = connect(mapStateToProps, mapActionCreators);

export type PropsFromRedux = ConnectedProps<typeof Connector>;
export default Connector;
